// Portal "Yıllar" görünümü toplam sütun grubu (portal yetki v2 Dalga 3, spec §8.3, §12/1 §12/3).
// Seçili yaprağın yıl kolonlarının SAĞINDA, HER YIL için bir salt-okunur sütun: tam kapsamda
// "Konsolide · {yıl}", kapsamlı ≥2 işletmede "Kapsamınızdaki işletmeler toplamı · {yıl}" (etiket her
// yerde `totalKind`'den — kapsamlıya "Konsolide" hiçbir yüzeyde yazılmaz). Başlık iki satır: üstte
// grup başlığı (`colSpan` = yıl sayısı, Σ işareti), altta yıl başlıkları. Hücreler `aggregate` sütun
// tipidir (KpiGrid: tıklanınca `scopeTotalReadonlyHint` / `consolidatedReadonlyHint`). Grup yoksa
// (danışman, tek işletme, `none`) hiçbir şey çizilmez ve başlık tek satır kalır (byte-eşit).

import { KPI_TOTAL_KIND_LABELS, type KpiTotalKind } from "@mahir/shared";
import { isTotalColumn, type GridColumn } from "../../lib/kpi-grid-nav";
import { yearHeaderLabel } from "../../lib/kpi-ui";

/**
 * Grup başlık satırının İLK tahmini yüksekliği (tek satır etiket). Gerçek yükseklik etiket sarılınca
 * büyür; `KpiGridHead` satırı ölçer ve ikinci satırın sticky `top`'unu ölçülen değerle verir.
 */
export const TOTAL_GROUP_ROW_HEIGHT = 33;

export function totalGroupColumns(columns: GridColumn[]): GridColumn[] {
  return columns.filter(isTotalColumn);
}

/** Üst satır grup başlığı: `colSpan` = yıl sayısı, "Σ {etiket}". */
export function TotalGroupHeader(props: {
  columns: GridColumn[];
  kind: Exclude<KpiTotalKind, "none">;
  style: React.CSSProperties;
}): JSX.Element | null {
  const years = totalGroupColumns(props.columns);
  if (years.length === 0) return null;
  return (
    <th
      colSpan={years.length}
      scope="colgroup"
      data-testid="kpi-total-group"
      style={{
        ...props.style,
        textAlign: "center",
        borderLeft: "1px solid var(--color-border)",
        background: "var(--color-bg)",
        whiteSpace: "normal",
      }}
    >
      <span aria-hidden="true">Σ </span>
      {KPI_TOTAL_KIND_LABELS[props.kind]}
    </th>
  );
}

/** Alt satır: yıl başlıkları (erişilebilir ad tam etiket: "Konsolide · 2025"). */
export function TotalYearHeaders(props: {
  columns: GridColumn[];
  style: React.CSSProperties;
  fiscalStartMonth: number;
  minWidth: number;
  /** ikinci satırın sticky ofseti = ölçülen birinci satır yüksekliği */
  top: number;
}): JSX.Element {
  return (
    <>
      {totalGroupColumns(props.columns).map((c, i) => (
        <th
          key={c.key}
          scope="col"
          aria-label={c.label}
          title={c.label}
          data-testid="kpi-total-year"
          style={{
            ...props.style,
            top: props.top,
            minWidth: props.minWidth,
            background: "var(--color-bg)",
            borderLeft: i === 0 ? "1px solid var(--color-border)" : undefined,
          }}
        >
          {yearHeaderLabel(c.year, props.fiscalStartMonth)}
        </th>
      ))}
    </>
  );
}
